import * as Yup from "yup";
import { ContractSettingsFormValues } from "../../Components/distributor-settings/subscriptions/contract-settings-table/mock-data";

// Validation schema for notification item
const notificationItemSchema = Yup.object().shape({
  id: Yup.number().required("Notification ID is required"),
  label: Yup.string().required("Notification label is required"),
  value: Yup.number()
    .min(0, "Notification value must be 0 or greater")
    .required("Notification value is required"),
  checked: Yup.boolean().required("Notification checked status is required"),
});

// Validation schema for email item
const emailItemSchema = Yup.object().shape({
  id: Yup.string().required("Email ID is required"),
  address: Yup.string()
    .email("Invalid email address")
    .required("Email address is required"),
});

// Validation schema for contract settings form
export const contractSettingsValidationSchema = Yup.object().shape({
  contractLength: Yup.number()
    .min(1, "Contract length must be at least 1 month")
    .integer("Contract length must be a whole number")
    .required("Contract length is required"),
  autoRenew: Yup.boolean().required("Auto-renew setting is required"),
  renewalNotifications: Yup.array()
    .of(notificationItemSchema)
    .min(1, "At least one renewal notification is required")
    .required("Renewal notifications are required"),
  isOverSubscriptionEnabled: Yup.boolean().required("Over-subscription setting is required"),
  isOverProspectEnabled: Yup.boolean().required("Over-prospect setting is required"),
  selectedPercentages: Yup.array()
    .of(Yup.string())
    .min(1, "At least one percentage must be selected")
    .required("Selected percentages are required"),
  emails: Yup.array()
    .of(emailItemSchema)
    .min(1, "At least one email address is required")
    .required("Emails are required"),
});

// Re-export the form values interface for convenience
export type { ContractSettingsFormValues };

